import Lenis from 'lenis';

export function lenisScroll() {
    const lenis = new Lenis();

    function raf(time) {
        // GSAP supplied seconds, so the previous `time * 2000`
        // is equivalent to doubling requestAnimationFrame's milliseconds.
        lenis.raf(time * 2);
        requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return lenis;
}
